import { messageCenterRequestUrl } from "@/utils/messageUrl";
import http from "./httpVideo";
import { BaseResponseType, MessageDetailType, MessageListType } from "@/types/message";



const {get,post}=http;


const baseUrlPerfix='/community-api'






/**
 * 消息中心 获取站内信 总数及未读消息
 * @returns 
 */
export const getMessageCount=():Promise<BaseResponseType>=>{
    return get(`${messageCenterRequestUrl.getMessageCount}`)
}

/**
 * 消息中心 获取消息列表
 * @returns 
 */
export const getMessageList=(params:any):Promise<MessageListType>=>{
    return get(`${messageCenterRequestUrl.getMessageList}`,{
      params:params
    })
}

/**
 * 获取消息详情
 * @param params 
 * @returns 
 */
export const getMessageDetail=(params:any):Promise<MessageDetailType>=>{
  
    return get(`${messageCenterRequestUrl.getMessageDetail}`,{
      params:params
    }
    )
}

/**
 *  标记已读
 * @param params 
 * @returns 
 */
export const readMessage=(params:any):Promise<BaseResponseType>=>{
    return post(`${messageCenterRequestUrl.readMessage}`,params)
}

/**
 * 删除消息
 * @param params 
 * @returns 
 */
export const deleteMessage=(params:any):Promise<BaseResponseType>=>{
    return http.delete(`${messageCenterRequestUrl.deleteMessage}`,{
      data:params
    })
}
/**
 * 获取下载链接
 * @param signTaskId 任务id
 * @returns 
 */
export const getDownloadUrl=(signTaskId:string,url:string):Promise<BaseResponseType>=>{
  return get(`${url}`,{
    params:{signTaskId}
  })
}
